import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmPasswordValidator } from '../../../_common/_helper/confirm-password.validator';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { CommonService } from '../../../_common/_service/user.service';
import { HeaderComponent } from '../../../_Shared/header/header.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  

  public changePasswordForm: FormGroup;
  submitted = false;
  currentUser: any;
  loadingspinner: boolean = false;


  constructor(
    private authService: AuthService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private _service: CommonService,
    private tokenStorageService: TokenStorageService,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.tokenStorageService.getEmployeeDetail2().subscribe(data => {
      
      if (data != "") {
        this.currentUser = data
  
      }
      else { this.currentUser = this.tokenStorageService.getUser(); }
    });

    this.changePasswordForm = this.fb.group({

      CurrentPassword: [null, [Validators.required]],
      NewPassword: [null, [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,20}')]],
      ConfirmPassword: [null, [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,20}')]],
      EmailId: this.currentUser.email
    }, {
        validator: ConfirmPasswordValidator('NewPassword', 'ConfirmPassword')
    })
  }

  ngOnInit() {
 
  }

  get f() { return this.changePasswordForm.controls; }
  
  changePassword(post:any) {
    
    this.submitted = true;
    if (this.changePasswordForm.valid) {
      this.loadingspinner = true;

      this.authService.changePassword(post).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; }) => {
        debugger;
        this.loadingspinner = false;
        if (response.apiStatus == true) {
          this.toastr.success(response.apiMessage, 'Success');
          this.dialogRef.close();

          this._service.callMethodOfSecondComponent(); 


        } else {
          this.toastr.error(response.apiMessage, 'Error');
        }

      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {
          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }
}
